// Whether a listing takes online bookings (DR-77). Named single-purpose file (CB-D3) so
// Home and Saved can ask without pulling the wizard's model into the entry chunk.
//
// The server-derived `bookable` (category in `bookable_categories` AND `booking_enabled`
// AND NOT `online_paused`, API-83) decides; older payloads without it fall back to the
// booking_enabled / online_paused pair. A listing that is not bookable is never offered a
// Book action: its hold would only answer 409 `category_not_bookable`.
export function isBookable(b: { bookable?: boolean; booking_enabled?: boolean; online_paused?: boolean }): boolean {
  return b.bookable ?? (b.booking_enabled !== false && b.online_paused !== true);
}
